import {Injectable} from "@angular/core";
import {ApiRequestService} from "./api-client/api-requests.service";
import {Constants} from "./utils/Constants";
import apiConfig from "./api-client/api-config";
import {HavApiRequestService} from "./api-client/hav-api-.service";

@Injectable()
export class HomeDeviceService {

  constructor(
    private apiService: ApiRequestService,
    private havApiService: HavApiRequestService
  ) {}

  getDevicesByHomeId(homeId: string) {
    let pathParams = {
      id: homeId,
    };
    return this.apiService
      .callApi(
        Constants.API_METHODS.GET,
        apiConfig.getDevicesByHomeId.uri,
        null,
        false,
        pathParams
      );
  }

  getHavDevicesByHomeId(homeId: string): any {
    let pathParams = {
      id: homeId,
    };
    return this.havApiService
      .executeHttp(
        Constants.API_METHODS.GET,
        apiConfig.getDevicesByHomeId.uri,
        null,
        false,
        pathParams
      );
  }


}
